import styled, { createGlobalStyle } from "styled-components";
import { NavLink } from "react-router-dom";

export const StyledNavLink = styled(NavLink)`
    transition: filter 0.15s ease, background-color 0.15s ease;

    &:hover {
        filter: brightness(1.06);
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${(props) => props.theme.shadowTypes.buttonFocus};
        position: relative;
        z-index: 1;
    }
`;

export const SideNavContainer = styled.div<{ $isExpanded: boolean }>`
    max-width: ${(props) => (props.$isExpanded ? "none" : "4.5em")};
    min-width: ${(props) => (props.$isExpanded ? "15em" : "auto")};

    @media screen and (max-width: 767px) {
        display: ${(props) => (props.$isExpanded ? undefined : "none")};
    }
`;

export const SideNavSectionHeader = styled.div`
    font-weight: 600;
    font-size: ${(props) => props.theme.font.sizes.sm};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    line-height: 2rem;
    color: ${(props) => props.theme.palette.text.hint};
`;

// UncontrolledTooltip (reactstrap) renders its content via a portal, outside
// this component's own DOM subtree — a normal scoped styled-component can't
// reach it, so this stays a small component-scoped global style instead.
// Rendered once inside <SideNav>.
export const SideNavTooltipGlobalStyle = createGlobalStyle`
    .sideNav-tooltip .tooltip-arrow {
        --bs-tooltip-bg: #3b3b3b;
    }
`;